export default function appendPlaceholders<T>(
  elements: T[] = [],
  numElementsGoal = 0,
): (T | { placeholder: boolean })[] {
  const numElements = elements ? elements.length : 0

  if (numElements >= numElementsGoal) {
    return elements
  }

  const placeholders = []
  const numPlaceholders = numElementsGoal - numElements

  for (let p = 0; p < numPlaceholders; p++) {
    placeholders.push({ placeholder: true })
  }

  return elements ? [...elements, ...placeholders] : placeholders
}
